// src/components/SeasonalSkins.js

export const SEASONAL_SKINS = {
  thanos: {
    boots: "/assets/seasonal/thanos/boots.png",
    head: "/assets/seasonal/thanos/head.png",
    pants: "/assets/seasonal/thanos/pants.png",
    shirt: "/assets/seasonal/thanos/shirt.png",
    weapons: "/assets/seasonal/thanos/weapons.png",
  },
  xmas: {
    background: "/assets/seasonal/Xmas/bg.png",
    boots: "/assets/seasonal/Xmas/boots.png",
    head: "/assets/seasonal/Xmas/head.png",
    pants: "/assets/seasonal/Xmas/pants.png",
    shirt: "/assets/seasonal/Xmas/shirt.png",
    weapons: "/assets/seasonal/Xmas/weapons.png",
  },
  commodus: {
    boots: "/assets/seasonal/commodus/boots.png",
    head: "/assets/seasonal/commodus/head.png",
    pants: "/assets/seasonal/commodus/pants.png",
    shirt: "/assets/seasonal/commodus/shirt.png",
    weapons: "/assets/seasonal/commodus/weapons.png",
  },
  sphinx: {
    boots: "/assets/seasonal/sphinx/boots.png",
    head: "/assets/seasonal/sphinx/head.png",
    mouth: "/assets/seasonal/sphinx/head.png",
    pants: "/assets/seasonal/sphinx/pants.png",
    shirt: "/assets/seasonal/sphinx/shirt.png",
    weapons: "/assets/seasonal/sphinx/weapons.png",
  },
  assassin: {
    body: "/assets/seasonal/assassin/body.png",
    boots: "/assets/seasonal/assassin/body.png",
    head: "/assets/seasonal/assassin/body.png",
    mouth: "/assets/seasonal/assassin/body.png",
    pants: "/assets/seasonal/assassin/body.png",
    shirt: "/assets/seasonal/assassin/body.png",
    weapons: "/assets/seasonal/assassin/body.png",
    eyes: "/assets/seasonal/assassin/body.png",
    face: "/assets/seasonal/assassin/body.png",
    neck: "/assets/seasonal/assassin/body.png",
  },
  horus: {
    body: "/assets/seasonal/horus/body.png",
    boots: "/assets/seasonal/horus/body.png",
    head: "/assets/seasonal/horus/body.png",
    mouth: "/assets/seasonal/horus/body.png",
    pants: "/assets/seasonal/horus/body.png",
    shirt: "/assets/seasonal/horus/body.png",
    weapons: "/assets/seasonal/horus/body.png",
    eyes: "/assets/seasonal/horus/body.png",
    face: "/assets/seasonal/horus/body.png",
    neck: "/assets/seasonal/horus/body.png",
  },
  anubis: {
    body: "/assets/seasonal/anubis/body.png",
    boots: "/assets/seasonal/anubis/body.png",
    head: "/assets/seasonal/anubis/body.png",
    mouth: "/assets/seasonal/anubis/body.png",
    pants: "/assets/seasonal/anubis/body.png",
    shirt: "/assets/seasonal/anubis/body.png",
    weapons: "/assets/seasonal/anubis/body.png",
    eyes: "/assets/seasonal/anubis/body.png",
    face: "/assets/seasonal/anubis/body.png",
    neck: "/assets/seasonal/anubis/body.png",
  },
  osiris: {
    body: "/assets/seasonal/osiris/body.png",
    boots: "/assets/seasonal/osiris/body.png",
    head: "/assets/seasonal/osiris/body.png",
    mouth: "/assets/seasonal/osiris/body.png",
    pants: "/assets/seasonal/osiris/body.png",
    shirt: "/assets/seasonal/osiris/body.png",
    weapons: "/assets/seasonal/osiris/body.png",
    eyes: "/assets/seasonal/osiris/body.png",
    face: "/assets/seasonal/osiris/body.png",
    neck: "/assets/seasonal/osiris/body.png",
  },
  ninja: {
    body: "/assets/seasonal/ninja/body.png",
    boots: "/assets/seasonal/ninja/body.png",
    head: "/assets/seasonal/ninja/body.png",
    mouth: "/assets/seasonal/ninja/body.png",
    pants: "/assets/seasonal/ninja/body.png",
    shirt: "/assets/seasonal/ninja/body.png",
    weapons: "/assets/seasonal/ninja/body.png",
    eyes: "/assets/seasonal/ninja/body.png",
    face: "/assets/seasonal/ninja/body.png",
    neck: "/assets/seasonal/ninja/body.png",
  },
  agamemnon: {
    body: "/assets/seasonal/agamemnon/body.png",
    boots: "/assets/seasonal/agamemnon/body.png",
    head: "/assets/seasonal/agamemnon/body.png",
    mouth: "/assets/seasonal/agamemnon/body.png",
    pants: "/assets/seasonal/agamemnon/body.png",
    shirt: "/assets/seasonal/agamemnon/body.png",
    weapons: "/assets/seasonal/agamemnon/body.png",
    eyes: "/assets/seasonal/agamemnon/body.png",
    face: "/assets/seasonal/agamemnon/body.png",
    neck: "/assets/seasonal/agamemnon/body.png",
  },
  skyrim: {
    body: "/assets/seasonal/skyrim/body.png",
    boots: "/assets/seasonal/skyrim/body.png",
    head: "/assets/seasonal/skyrim/body.png",
    mouth: "/assets/seasonal/skyrim/body.png",
    pants: "/assets/seasonal/skyrim/body.png",
    shirt: "/assets/seasonal/skyrim/body.png",
    weapons: "/assets/seasonal/skyrim/body.png",
    eyes: "/assets/seasonal/skyrim/body.png",
    face: "/assets/seasonal/skyrim/body.png",
    neck: "/assets/seasonal/skyrim/body.png",
  },
  anubis2: {
  body: "/assets/seasonal/anubis2/body.png",
  boots: "/assets/seasonal/anubis2/body.png",
  head: "/assets/seasonal/anubis2/body.png",
  mouth: "/assets/seasonal/anubis2/body.png",
  pants: "/assets/seasonal/anubis2/body.png",
  shirt: "/assets/seasonal/anubis2/body.png",
  weapons: "/assets/seasonal/anubis2/body.png",
  eyes: "/assets/seasonal/anubis2/body.png",
  face: "/assets/seasonal/anubis2/body.png",
  neck: "/assets/seasonal/anubis2/body.png",
},

croc: {
  body: "/assets/seasonal/croc/body.png",
  boots: "/assets/seasonal/croc/body.png",
  head: "/assets/seasonal/croc/body.png",
  mouth: "/assets/seasonal/croc/body.png",
  pants: "/assets/seasonal/croc/body.png",
  shirt: "/assets/seasonal/croc/body.png",
  weapons: "/assets/seasonal/croc/body.png",
  eyes: "/assets/seasonal/croc/body.png",
  face: "/assets/seasonal/croc/body.png",
  neck: "/assets/seasonal/croc/body.png",
},

croc2: {
  body: "/assets/seasonal/croc2/body.png",
  boots: "/assets/seasonal/croc2/body.png",
  head: "/assets/seasonal/croc2/body.png",
  mouth: "/assets/seasonal/croc2/body.png",
  pants: "/assets/seasonal/croc2/body.png",
  shirt: "/assets/seasonal/croc2/body.png",
  weapons: "/assets/seasonal/croc2/body.png",
  eyes: "/assets/seasonal/croc2/body.png",
  face: "/assets/seasonal/croc2/body.png",
  neck: "/assets/seasonal/croc2/body.png",
},

cobra: {
  body: "/assets/seasonal/cobra/body.png",
  boots: "/assets/seasonal/cobra/body.png",
  head: "/assets/seasonal/cobra/body.png",
  mouth: "/assets/seasonal/cobra/body.png",
  pants: "/assets/seasonal/cobra/body.png",
  shirt: "/assets/seasonal/cobra/body.png",
  weapons: "/assets/seasonal/cobra/body.png",
  eyes: "/assets/seasonal/cobra/body.png",
  face: "/assets/seasonal/cobra/body.png",
  neck: "/assets/seasonal/cobra/body.png",
},

falcon: {
  body: "/assets/seasonal/falcon/body.png",
  boots: "/assets/seasonal/falcon/body.png",
  head: "/assets/seasonal/falcon/body.png",
  mouth: "/assets/seasonal/falcon/body.png",
  pants: "/assets/seasonal/falcon/body.png",
  shirt: "/assets/seasonal/falcon/body.png",
  weapons: "/assets/seasonal/falcon/body.png",
  eyes: "/assets/seasonal/falcon/body.png",
  face: "/assets/seasonal/falcon/body.png",
  neck: "/assets/seasonal/falcon/body.png",
},

fireserpent: {
  body: "/assets/seasonal/fireserpent/body.png",
  boots: "/assets/seasonal/fireserpent/body.png",
  head: "/assets/seasonal/fireserpent/body.png",
  mouth: "/assets/seasonal/fireserpent/body.png",
  pants: "/assets/seasonal/fireserpent/body.png",
  shirt: "/assets/seasonal/fireserpent/body.png",
  weapons: "/assets/seasonal/fireserpent/body.png",
  eyes: "/assets/seasonal/fireserpent/body.png",
  face: "/assets/seasonal/fireserpent/body.png",
  neck: "/assets/seasonal/fireserpent/body.png",
},

jackal: {
  body: "/assets/seasonal/jackal/body.png",
  boots: "/assets/seasonal/jackal/body.png",
  head: "/assets/seasonal/jackal/body.png",
  mouth: "/assets/seasonal/jackal/body.png",
  pants: "/assets/seasonal/jackal/body.png",
  shirt: "/assets/seasonal/jackal/body.png",
  weapons: "/assets/seasonal/jackal/body.png",
  eyes: "/assets/seasonal/jackal/body.png",
  face: "/assets/seasonal/jackal/body.png",
  neck: "/assets/seasonal/jackal/body.png",
},

maat: {
  body: "/assets/seasonal/maat/body.png",
  boots: "/assets/seasonal/maat/body.png",
  head: "/assets/seasonal/maat/body.png",
  mouth: "/assets/seasonal/maat/body.png",
  pants: "/assets/seasonal/maat/body.png",
  shirt: "/assets/seasonal/maat/body.png",
  weapons: "/assets/seasonal/maat/body.png",
  eyes: "/assets/seasonal/maat/body.png",
  face: "/assets/seasonal/maat/body.png",
  neck: "/assets/seasonal/maat/body.png",
},

mummypriest: {
  body: "/assets/seasonal/mummypriest/body.png",
  boots: "/assets/seasonal/mummypriest/body.png",
  head: "/assets/seasonal/mummypriest/body.png",
  mouth: "/assets/seasonal/mummypriest/body.png",
  pants: "/assets/seasonal/mummypriest/body.png",
  shirt: "/assets/seasonal/mummypriest/body.png",
  weapons: "/assets/seasonal/mummypriest/body.png",
  eyes: "/assets/seasonal/mummypriest/body.png",
  face: "/assets/seasonal/mummypriest/body.png",
  neck: "/assets/seasonal/mummypriest/body.png",
},

ra: {
  body: "/assets/seasonal/ra/body.png",
  boots: "/assets/seasonal/ra/body.png",
  head: "/assets/seasonal/ra/body.png",
  mouth: "/assets/seasonal/ra/body.png",
  pants: "/assets/seasonal/ra/body.png",
  shirt: "/assets/seasonal/ra/body.png",
  weapons: "/assets/seasonal/ra/body.png",
  eyes: "/assets/seasonal/ra/body.png",
  face: "/assets/seasonal/ra/body.png",
  neck: "/assets/seasonal/ra/body.png",
},

carab: {
  body: "/assets/seasonal/carab/body.png",
  boots: "/assets/seasonal/carab/body.png",
  head: "/assets/seasonal/carab/body.png",
  mouth: "/assets/seasonal/carab/body.png",
  pants: "/assets/seasonal/carab/body.png",
  shirt: "/assets/seasonal/carab/body.png",
  weapons: "/assets/seasonal/carab/body.png",
  eyes: "/assets/seasonal/carab/body.png",
  face: "/assets/seasonal/carab/body.png",
  neck: "/assets/seasonal/carab/body.png",
},

sphynx: {
  body: "/assets/seasonal/sphynx/body.png",
  boots: "/assets/seasonal/sphynx/body.png",
  head: "/assets/seasonal/sphynx/body.png",
  mouth: "/assets/seasonal/sphynx/body.png",
  pants: "/assets/seasonal/sphynx/body.png",
  shirt: "/assets/seasonal/sphynx/body.png",
  weapons: "/assets/seasonal/sphynx/body.png",
  eyes: "/assets/seasonal/sphynx/body.png",
  face: "/assets/seasonal/sphynx/body.png",
  neck: "/assets/seasonal/sphynx/body.png",
},

toth: {
  body: "/assets/seasonal/toth/body.png",
  boots: "/assets/seasonal/toth/body.png",
  head: "/assets/seasonal/toth/body.png",
  mouth: "/assets/seasonal/toth/body.png",
  pants: "/assets/seasonal/toth/body.png",
  shirt: "/assets/seasonal/toth/body.png",
  weapons: "/assets/seasonal/toth/body.png",
  eyes: "/assets/seasonal/toth/body.png",
  face: "/assets/seasonal/toth/body.png",
  neck: "/assets/seasonal/toth/body.png",
},

spider: {
  body: "/assets/seasonal/spider/body.png",
  boots: "/assets/seasonal/spider/body.png",
  head: "/assets/seasonal/spider/body.png",
  mouth: "/assets/seasonal/spider/body.png",
  pants: "/assets/seasonal/spider/body.png",
  shirt: "/assets/seasonal/spider/body.png",
  weapons: "/assets/seasonal/spider/body.png",
  eyes: "/assets/seasonal/spider/body.png",
  face: "/assets/seasonal/spider/body.png",
  neck: "/assets/seasonal/spider/body.png",
},

frankenstein: {
  body: "/assets/seasonal/frankenstein/body.png",
  boots: "/assets/seasonal/frankenstein/body.png",
  head: "/assets/seasonal/frankenstein/body.png",
  mouth: "/assets/seasonal/frankenstein/body.png",
  pants: "/assets/seasonal/frankenstein/body.png",
  shirt: "/assets/seasonal/frankenstein/body.png",
  weapons: "/assets/seasonal/frankenstein/body.png",
  eyes: "/assets/seasonal/frankenstein/body.png",
  face: "/assets/seasonal/frankenstein/body.png",
  neck: "/assets/seasonal/frankenstein/body.png",
},
ghostface: {
  body: "/assets/seasonal/ghostface/body.png",
  boots: "/assets/seasonal/ghostface/body.png",
  head: "/assets/seasonal/ghostface/body.png",
  mouth: "/assets/seasonal/ghostface/body.png",
  pants: "/assets/seasonal/ghostface/body.png",
  shirt: "/assets/seasonal/ghostface/body.png",
  weapons: "/assets/seasonal/ghostface/body.png",
  eyes: "/assets/seasonal/ghostface/body.png",
  face: "/assets/seasonal/ghostface/body.png",
  neck: "/assets/seasonal/ghostface/body.png",
},
frostknight: {
  body: "/assets/seasonal/frostknight/body.png",
  boots: "/assets/seasonal/frostknight/body.png",
  head: "/assets/seasonal/frostknight/body.png",
  mouth: "/assets/seasonal/frostknight/body.png",
  pants: "/assets/seasonal/frostknight/body.png",
  shirt: "/assets/seasonal/frostknight/body.png",
  weapons: "/assets/seasonal/frostknight/body.png",
  eyes: "/assets/seasonal/frostknight/body.png",
  face: "/assets/seasonal/frostknight/body.png",
  neck: "/assets/seasonal/frostknight/body.png",
},
boinkers: {
  body: "/assets/seasonal/boinkers/body.png",
  boots: "/assets/seasonal/boinkers/body.png",
  head: "/assets/seasonal/boinkers/body.png",
  mouth: "/assets/seasonal/boinkers/body.png",
  pants: "/assets/seasonal/boinkers/body.png",
  shirt: "/assets/seasonal/boinkers/body.png",
  weapons: "/assets/seasonal/boinkers/body.png",
  eyes: "/assets/seasonal/boinkers/body.png",
  face: "/assets/seasonal/boinkers/body.png",
  neck: "/assets/seasonal/boinkers/body.png",
},

};

export function getSkinSrc(season, part, defaultSrc) {
  if (!season) return defaultSrc;

  const key = String(season).trim().toLowerCase();
  const skin = SEASONAL_SKINS[key];

  if (!skin) return defaultSrc;
  return skin[part] || defaultSrc;
}